import { render, staticRenderFns } from "./FrameModal.vue?vue&type=template&id=77e3898e&scoped=true&"
import script from "./FrameModal.vue?vue&type=script&lang=js&"
export * from "./FrameModal.vue?vue&type=script&lang=js&"
import style0 from "./FrameModal.vue?vue&type=style&index=0&id=77e3898e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e3898e",
  null
  
)

export default component.exports